module.exports = __webpack_public_path__ + "static/media/tmb_shells-logo.b52f90c7.png";